import EmiSchemesRepository from "@/repositories/creditengine/EmiSchemesRepository";
import SmsRepository from "@/repositories/creditengine/SmsRepository";
import WebviewRepository from "@/repositories/creditengine/WebviewRepository";
import LoanStageRepository from "@/repositories/creditengine/LoanStageRepository";
import AttributeRepository from "@/repositories/creditengine/AttributeRepository";
import LeadRepository from "@/repositories/creditengine/LeadRepository";
import PanRepository from "@/repositories/creditengine/PanRepository";
import LoanCreditEngineRepository from "@/repositories/creditengine/LoanCreditEngineRepository";
import ClientCreditEngineRepository from "@/repositories/creditengine/ClientCreditEngineRepository";
import AddressRepository from "@/repositories/creditengine/AddressRepository";
import MandateRepository from "@/repositories/creditengine/MandateRepository";
import SignRepository from "@/repositories/creditengine/SignRepository";
import PerfiosRepository from "@/repositories/creditengine/PerfiosRepository";
import DocumentRepository from "@/repositories/creditengine/DocumentRepository";
import BankRepository from "@/repositories/creditengine/BankRepository";
import MailRepository from "@/repositories/creditengine/MailRepository";
import LenderRepository from "@/repositories/creditengine/LenderRepository";

const repositories = {
  emiSchemes: EmiSchemesRepository,
  sms: SmsRepository,
  webview: WebviewRepository,
  loanStage: LoanStageRepository,
  attribute: AttributeRepository,
  lead: LeadRepository,
  pan: PanRepository,
  loan: LoanCreditEngineRepository,
  client: ClientCreditEngineRepository,
  mandate: MandateRepository,
  sign: SignRepository,
  perfios: PerfiosRepository,
  address: AddressRepository,
  document: DocumentRepository,
  bank: BankRepository,
  mail: MailRepository,
  lender: LenderRepository,
  // other repositories ...
};

export const CreditEngineRepositoryFactory = {
  EMI_SCHEMES: "emiSchemes",
  SMS: "sms",
  LOAN_STAGE: "loanStage",
  LEAD: "lead",
  PAN: "pan",
  LOAN: "loan",
  CLIENT: "client",
  ADDRESS: "address",
  MANDATE: "mandate",
  SIGN: "sign",
  ATTRIBUTE: "attribute",
  PERFIOS: "perfios",
  DOCUMENT: "document",
  BANK: "bank",
  MAIL: "mail",
  WEBVIEW: "webview",
  LENDER: "lender",
  get: name => repositories[name]
};
